import { Button, Grid, Group, Modal, NumberInput, Text } from '@mantine/core';
import { IconDeviceFloppy } from '@tabler/icons-react';
import { useEffect, useRef, useState } from 'react';
import UnlayerEditor from '../Editors/UnlayerEditor';
import mergeTagsForEmailEditor from '../mergeTagsForEmailEditor';

const StorySlideEditor = ({ slide, mergeTags, onSave, onClose, opened }) => {
  const unlayerEditor = useRef(null);
  const [unlayerLoaded, setUnlayerLoaded] = useState(false);
  const [slideData, setSlideData] = useState(slide || {});

  useEffect(() => {
    if (slide) {
      setSlideData(slide);
    }
    setUnlayerLoaded(false);
  }, [slide]);

  const handleChange = (name, value) => {
    setSlideData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = () => {
    if (slideData.editor === 'visual' && unlayerEditor.current) {
      unlayerEditor.current.exportHtml(({ design, chunks }) => {
        onSave({
          ...slideData,
          design,
          html: chunks.body
            .replace(/min-height: 100vh; /g, '')
            .replace(
              '<div id="u_body" class="u_body" style="min-height: 100vh;">',
              '<style>.u-row{display:flex;flex-wrap:nowrap;margin-left:0;margin-right:0}.u-row .u-col{position:relative;width:100%;padding-right:0;padding-left:0}.u-row .u-col.u-col-16p67{flex:0 0 16.67%;max-width:16.67%}.u-row .u-col.u-col-25{flex:0 0 25%;max-width:25%}.u-row .u-col.u-col-33p33{flex:0 0 33.33%;max-width:33.33%}.u-row .u-col.u-col-50{flex:0 0 50%;max-width:50%}.u-row .u-col.u-col-100{flex:0 0 100%;max-width:100%}@media (max-width:767px){.u-row:not(.no-stack){flex-wrap:wrap}.u-row:not(.no-stack) .u-col{flex:0 0 100%!important;max-width:100%!important}}.layout-mobile .u-row:not(.no-stack){flex-wrap:wrap}.layout-mobile .u-row:not(.no-stack) .u-col{flex:0 0 100%!important;max-width:100%!important}@media (max-width:480px){.hide-mobile{display:none!important}.container{max-width:100%!important}}@media (min-width:481px) and (max-width:768px){.hide-tablet{display:none!important}}@media (min-width:481px){.hide-desktop{display:none!important}}</style><div id="u_body" class="u_body" style="width: 100%;">',
            ),
        });
      });
    } else {
      onSave(slideData);
    }
  };

  if (!slide) return null;

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      size="full"
      title="Edit Slide"
      styles={{ content: { width: '100%', maxWidth: '100%' } }}
    >
      <Grid mb="md">
        <Grid.Col span={{ base: 12, sm: 4 }}>
          <NumberInput
            label="Duration override (seconds)"
            description="Leave empty to use the story's default auto-play duration"
            placeholder="Use story default"
            min={1}
            step={1}
            value={slideData.durationSeconds || ''}
            onChange={(value) => handleChange('durationSeconds', value || null)}
          />
        </Grid.Col>
      </Grid>

      <Text size="sm" fw={500} mb="xs">
        Slide Content
      </Text>
      <UnlayerEditor
        editorHeight="60vh"
        design={slideData.design || ''}
        editorRef={unlayerEditor}
        displayMode="web"
        onLoad={() => setUnlayerLoaded(true)}
        projectId="65057"
        mergeTags={mergeTagsForEmailEditor(mergeTags)}
        tools={{
          form: {
            properties: {
              action: {
                editor: {
                  data: {
                    allowCustomUrl: true,
                  },
                },
              },
            },
          },
        }}
      />

      <Group justify="flex-end" mt="md">
        <Button variant="default" onClick={onClose}>
          Cancel
        </Button>
        <Button onClick={handleSave} disabled={slideData.editor === 'visual' && !unlayerLoaded}>
          <IconDeviceFloppy size={14} /> Save Slide
        </Button>
      </Group>
    </Modal>
  );
};

export default StorySlideEditor;
